import { Directive, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appZeroOnEmpty]',
  standalone: true,
  host: {
    '(focusout)': 'onFocusOut($event)',
  },
})
export class ZeroOnEmptyDirective {
  private readonly _ngControl = inject(NgControl);

  onFocusOut(event: FocusEvent): void {
    const control = this._ngControl.control;
    if (!control) return;

    const target = event.target as HTMLInputElement | null;
    const rawValue =
      target?.value !== undefined && target?.value !== null
        ? target.value
        : control.value;

    const displayValue = String(rawValue ?? '').trim();

    if (displayValue !== '') return;

    control.setValue(0);

    if (target) {
      target.value = '0';
    }
  }
}
